import React, { useEffect, useState } from 'react';
import Loading from '../../utils/Loading';
import { useServerWakeup } from '../../utils/serverWakeup';

// Prikazuje se preko cele stranice dok se backend na Render-u budi (može da potraje do ~1 minut).
function ServerWakeupModal() {
    const { visible, since, gaveUp } = useServerWakeup();
    const [seconds, setSeconds] = useState(0);

    useEffect(() => {
        if (!visible || !since) {
            setSeconds(0);
            return;
        }
        const tick = () => setSeconds(Math.floor((Date.now() - since) / 1000));
        tick();
        const timer = setInterval(tick, 1000);
        return () => clearInterval(timer);
    }, [visible, since]);

    if (!visible) return null;

    return (
        <div className="fixed inset-0 z-[10000] flex items-center justify-center bg-black/60 px-4" role="alertdialog" aria-live="polite">
            <div className="w-full max-w-[420px] rounded-2xl bg-white p-6 text-center shadow-xl">
                {!gaveUp && (
                    <div className="mb-4 flex justify-center">
                        <Loading size={56} primaryColor="#19315f" secondaryColor="#d9deea" />
                    </div>
                )}
                <p className="text-[20px] font-bold leading-6 text-blueDark">{gaveUp ? 'Server još uvek ne odgovara' : 'Server se budi'}</p>
                <p className="mt-2 text-[16px] leading-5 text-[#667080]">
                    {gaveUp
                        ? 'Pokušajte ponovo za nekoliko trenutaka.'
                        : 'Ovo može da potraje do 1 minut. Molimo vas da sačekate, stranica će se učitati sama.'}
                </p>
                {!gaveUp && <p className="mt-3 text-[14px] text-[#667080]">Prošlo: {seconds} s</p>}
                {gaveUp && (
                    <button
                        type="button"
                        onClick={() => window.location.reload()}
                        className="mt-4 rounded-lg bg-blueDark px-5 py-2 text-[16px] font-semibold text-white"
                    >
                        Pokušaj ponovo
                    </button>
                )}
            </div>
        </div>
    );
}

export default ServerWakeupModal;
